// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"3136d45b","780":"ea69da22"}[chunkId] + ".chunk.js";
};